import { apiUrl } from "./base";
const intelliTriageBaseUrl = import.meta.env.VITE_INTELLITRIAGE_BASE_URL
const rankingPipelineUrl = import.meta.env.VITE_RANKING_INTAKE_URL || "http://localhost:7103/api/";
export interface IntakeProcessResponse {
  fileName?: string;
  sizeBytes?: number;
  processedContentSummary?: string;
  message?: string;
  likelihood?: number;
  narrative?: string;
}

/**
 * POST a WAV file to the IntakeProcessing/process endpoint.
 * Form field name must be "uploadedFile" to match the backend.
 */
export async function processIntakeFile(
  file: File
): Promise<IntakeProcessResponse> {
  const url = `${intelliTriageBaseUrl}/api/v1/IntakeProcessing/process`;
  const formData = new FormData();
  formData.append("uploadedFile", file);

  const res = await fetch(url, {
    method: "POST",
    body: formData,
  });

  const data = await res.json().catch(() => ({})) as IntakeProcessResponse & { message?: string };

  if (!res.ok) {
    throw {
      statusCode: res.status,
      message:
        data.message ||
        res.statusText ||
        `Request failed with status ${res.status}`,
    };
  }

  return data;
}

export async function processIntakeText(
  text: string
): Promise<IntakeProcessResponse> {
  const url =`${intelliTriageBaseUrl}/api/v1/IntakeProcessing/process-text`;

  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(text),
  });

  const data = (await res.json().catch(() => ({}))) as IntakeProcessResponse & {
    message?: string;
  };

  if (!res.ok) {
    throw {
      statusCode: res.status,
      message:
        data.message ||
        res.statusText ||
        `Request failed with status ${res.status}`,
    };
  }



  console.log("data processIntakeText.ts", data);
  return data;
}
